<a [routerLink]="accountPageLink().path" class="block py-3 font-medium">
  {{ accountPageLink().title }}
</a>
<p-divider class="p-0 m-0"/>
